import React from 'react'
import { TFunction } from 'i18next'

export type SpaceReservationKeyDisplayProps = {
  keyNumber: string | null
  hasQrCode: boolean
  universalAccessKeyUrl: string | null
  linkColor: string
  t: TFunction
}

function normalizeUrl(url: string | null | undefined): string | null {
  if (url == null || url.trim() === '') return null
  return url.trim()
}

/**
 * メールの space-reserve-info-reminder と同様（isAccessKeyTypeOther = hasQrCode）:
 * - universalAccessKeyUrl 空 → 鍵番号のみ（リンクなし）
 * - URL ありかつ QR コードなし → 鍵番号のみをリンク（別文言リンクは出さない）
 * - URL ありかつ QR コードあり → 鍵番号 + 半角 () の外側、内側の文言のみリンク
 */
export function SpaceReservationKeyDisplayValue({
  keyNumber,
  hasQrCode,
  universalAccessKeyUrl,
  linkColor,
  t,
}: SpaceReservationKeyDisplayProps): React.ReactNode {
  if (!keyNumber || keyNumber.trim() === '') return null

  const url = normalizeUrl(universalAccessKeyUrl ?? undefined)
  const linkStyle: React.CSSProperties = { color: linkColor, textDecoration: 'underline' }

  if (!url) {
    return <>{keyNumber}</>
  }

  if (!hasQrCode) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {keyNumber}
      </a>
    )
  }

  return (
    <>
      {keyNumber}{' '}
      {'('}
      <a href={url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {t('QR code for unlocking link')}
      </a>
      {')'}
    </>
  )
}
